import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal"
import luckyDrawModel from "@/models/lucky-draw/lucky-draw"
import router from "@/router"
import store from "@/store"
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable"
import usePagination from "@/views/components/pagination/usePagination"
import useFlatPickr from "@/utils/hooks/useFlatPickr"
import { onBeforeMount, reactive, ref, watch } from "@vue/composition-api"
import useModal from "@/@core/components/base-modal/hooks/useModal";

export default function useCampaignList() {
  const { openModal, closeModal } = useModal();
  const {
    fetchCampaignList,
    setCampaignStatus,
    deleteCampaign
  } = luckyDrawModel()
  const {
    pagination,
    onPageChange,
    onFilterEntity
  } = usePagination()
  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable()

  const {
    openDefaultErrorModal,
    openWarningModal,
    openErrorModal,
    openSuccessModal,
  } = useValidationModal()

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDateString,
    resolveDate,
    resolveTime,
  } = useFlatPickr()

  const modalPopup = reactive({
    report: false,
  });

  const onOpenExportModal = () => {
    modalPopup.report = true;
    openModal();
  };

  const closeReportModal = () => {
    modalPopup.report = false;
    closeModal();
  };
  const loading = reactive({
    tableData: false,
  })

  const campaignSelect = ref(null)

  const fields = [
    { key: "seq", label: "No" },
    { key: "main_image_url", label: "Image" },
    { key: "name", label: "Title Name" },
    { key: 'created_by', label: "Created By" },
    { key: "start_date", label: "Valid From" },
    { key: "end_date", label: "Valid Through" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ]

  const statusOption = ref([
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ])

  const status = ref(0)

  const campaignListTable = reactive({
    payload: [],
  })

  const LuckyDrawActionList = reactive({
    edit: {
      label: "Edit",
      value: 1,
      icon: "IconEditWinner",
      display: true,
    },

    delete: {
      label: "Delete",
      value: 7,
      icon: "DeleteIcon",
      display: true,
    },
  });

  const resolveMappingTableAction = (type, item) => {
    switch (type) {
      case 1:
        setDefaultActiveTab();
        router.push(`/lucky-draw/campaign/info/${item.item
          .id}`);
        return;

      case 7:
        onRemoveCampaign(item.item);
      default:
    }
  };

  const setDefaultActiveTab = () => {
    localStorage.removeItem("activeTab");
  };

  const fetchLuckyDrawCampaignList = () => {
    loading.tableData = true
    fetchCampaignList.payload.Page = pagination.currentPage
    fetchCampaignList.payload.Limit = pagination.perPage
    fetchCampaignList.payload.Filters = filters
    fetchCampaignList.payload.Ordering = ordering.value;
    store
      .dispatch('api/apiRequest', fetchCampaignList)
      .then(response => {
        if (response.status == "success") {
          campaignListTable.payload = response.data.resp.map((item) => ({
            seq: item.seq,
            id: item.campaign.luckydraw_campaignid,
            main_image_url: item.campaign.main_image_url,
            created_by: item.created_by,
            name: item.campaign.campaign_name_th,
            name: item.campaign.campaign_name_th,
            start_date: `${resolveDate(item.campaign.valid_form)} ${resolveTime(item.campaign.valid_form)}`,
            end_date: `${resolveDate(item.campaign.valid_through)} ${resolveTime(item.campaign.valid_through)}`,
            status: item.campaign.status
          }))
          pagination.rows = response.data.resp.length
          pagination.totalRows = response.data.filtered_record ?? response.data.resp.length
        }
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  const onRemoveCampaign = (item) => {
    openWarningModal(
      "ลบ Campaign",
      `ต้องการลบรายการ ${item.name} นี้หรือไม่ ?`,
      () => {
        deleteCampaign.payload.CampaignId = item.id;

        store
          .dispatch("api/apiRequest", deleteCampaign)
          .then((response) => {
            openSuccessModal(
              "ลบรายการสำเร็จ !",
              null,
              "ตกลง",
              () => {
                fetchLuckyDrawCampaignList();
              },
              () => { }
            );
          })
          .catch((error) => {
            loading.tableData = false;
            openErrorModal(error);
          })
          .finally(() => { });
      }
    );
  };

  const onToggleStatus = (status, campaign) => {
    loading.tableData = true
    setCampaignStatus.payload.CampaignId = campaign.id
    setCampaignStatus.payload.Status = status ? 1 : 2;
    store
      .dispatch('api/apiRequest', setCampaignStatus)
      .then(response => {
        fetchLuckyDrawCampaignList()
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchLuckyDrawCampaignList()
      }
    },
    { deep: true }
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchLuckyDrawCampaignList()
    },
    { deep: true }
  )

  onBeforeMount(() => {
    fetchLuckyDrawCampaignList()
  })

  return {
    fields,
    loading,
    statusOption,
    status,
    campaignListTable,
    pagination,
    campaignSelect,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,
    onToggleStatus,
    modalPopup,
    onOpenExportModal,
    closeReportModal,
    LuckyDrawActionList,
    resolveMappingTableAction
  }
}
